import * as utils from "ethers/utils"

export function fromWei(wei) {
  return +utils.formatEther(wei.toString())
}

export function toWei(eth) {
  return utils.parseEther(eth.toString())
}

export const solidityKeccak = utils.solidityKeccak256

export function stringToBytes32(str) {
  return utils.hexlify(utils.toUtf8Bytes(str)).padEnd(66, "0")
}

export default {
  fromWei,
  toWei,
  solidityKeccak,
  stringToBytes32
}

// export { default as getContract } from "./getContract"
// export { default as getMinedTx } from "./getMinedTx"
// export { default as getWeb3 } from "./getWeb3"
// export { default as promtract } from "./promtract"
